export default (valor, percentual, aPartirDe, quatidade ) => {
    if (quatidade >= aPartirDe)
        return Number(valor - (valor * (percentual / 100))).toFixed(3)
    else return Number(valor)
}